var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text text-primary text-right"},[_vm._v(" "+_vm._s(_vm.$n(_vm.row.value, 'currency'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }